import { IconPropsType } from '..';

export const HamburgerIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.6 24C13.6 24.4418 13.9581 24.8 14.4 24.8H25.6C26.0418 24.8 26.4 24.4418 26.4 24C26.4 23.5581 26.0418 23.2 25.6 23.2H14.4C13.9581 23.2 13.6 23.5581 13.6 24ZM13.6 20C13.6 20.4418 13.9581 20.8 14.4 20.8H25.6C26.0418 20.8 26.4 20.4418 26.4 20C26.4 19.5581 26.0418 19.2 25.6 19.2H14.4C13.9581 19.2 13.6 19.5581 13.6 20ZM13.6 16C13.6 16.4418 13.9581 16.8 14.4 16.8H25.6C26.0418 16.8 26.4 16.4418 26.4 16C26.4 15.5581 26.0418 15.2 25.6 15.2H14.4C13.9581 15.2 13.6 15.5581 13.6 16Z"
      fill="#9CA2C2"
    />
  </svg>
);
